var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75333 0.893252C9.51333 0.553252 9.11333 0.333252 8.66667 0.333252L1.33333 0.339919C0.6 0.339919 0 0.933252 0 1.66659V8.33325C0 9.06659 0.6 9.65992 1.33333 9.65992L8.66667 9.66659C9.11333 9.66659 9.51333 9.44659 9.75333 9.10659L12.6667 4.99992L9.75333 0.893252Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTags);
export default __webpack_public_path__ + "static/media/add_tags.3d7602fd960c06ceecd31cd45eaf3ce3.svg";
export { ForwardRef as ReactComponent };